import { OrderDocumentCategory } from '../types';

export const OrderDocumentCategories: OrderDocumentCategory[] = [
    { id: 100, name: 'CMR' },
    { id: 99, name: 'Акт выполненных работ' },
    { id: 11, name: 'Акт расхождения' },
    { id: 12, name: 'Заявление на утилизацию' },
    { id: 740, name: 'Письмо о смене отправителя' },
    { id: 96, name: 'Письмо о смене плательщика' },
    { id: 741, name: 'Письмо о смене получателя' },
    { id: 97, name: 'Письмо об изменении города назначения' },
    { id: 98, name: 'Письмо об отказе от перевозки' },
    { id: 13, name: 'Подтверждение выдачи' },
    { id: 14, name: 'Подтверждение простоя' },
    { id: 3608, name: 'Подтверждение цепочки международной перевозки' },
    { id: 15, name: 'Сопроводительные документы' },
    { id: 16, name: 'Фото груза' },
    { id: 0, name: 'Другое' },
];
